var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "column-layout clearfix", staticStyle: { height: "100%" } },
    [
      _c(
        "div",
        { staticClass: "left-column fl", class: { active: !_vm.treeCollapse } },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "tree-menu" } },
            [
              _c("swb-org-tree", {
                attrs: {
                  merchantId: _vm.merchantId,
                  isCom: true,
                  enableSearch: true,
                  bizDepart: true
                },
                on: {
                  "notity-change": function($event) {
                    _vm.notityChange($event)
                  },
                  "show-tree-collapse": function($event) {
                    _vm.showTreeCollapse($event)
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right-column fl", staticStyle: { height: "100%" } },
        [
          _c("div", { staticClass: "simple-row" }, [
            _c(
              "div",
              { staticClass: "right" },
              [
                _c("swb-mercht-select-popover", {
                  attrs: {
                    merchantType: "servicer",
                    defSelectId: _vm.merchantId,
                    selectHandler: _vm.selectMerchtHandler
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "table-layout",
              staticStyle: { "overflow-y": "auto", height: "calc(100% - 44px)" }
            },
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.roleList, border: "", "row-key": "id" },
                  on: { "row-click": _vm.handleSelectionChange }
                },
                [
                  _vm.checkBoxFlag
                    ? _c("el-table-column", {
                        attrs: {
                          selectable: _vm.selectable,
                          align: "center",
                          type: "selection",
                          width: "55"
                        }
                      })
                    : _c("el-table-column", {
                        attrs: { align: "center", width: "55" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                _c(
                                  "el-radio",
                                  {
                                    attrs: { label: rows.row.id },
                                    model: {
                                      value: _vm.checkedRoleInfo.id,
                                      callback: function($$v) {
                                        _vm.$set(_vm.checkedRoleInfo, "id", $$v)
                                      },
                                      expression: "checkedRoleInfo.id"
                                    }
                                  },
                                  [_vm._v(" ")]
                                )
                              ]
                            }
                          }
                        ])
                      }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "岗位名称" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "mobAppRoleName",
                      label: "移动端功能",
                      width: "120"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.mobAppRoleName != null
                              ? _c("span", [_vm._v("可用")])
                              : _c("span", { staticClass: "font-red" }, [
                                  _vm._v("不可用")
                                ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tab-container base" }, [
      _c("div", { staticClass: "tabs-nav" }, [
        _c("ul", { staticClass: "head" }, [
          _c("li", { staticClass: "head-item current" }, [_vm._v("组织机构")])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b4738ec2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4738ec2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/authx/StaffRoleListForSelect.vue
// module id = 2217
// module chunks = 1